import React, {useState, useEffect, useCallback} from 'react';

import p1_bImg from '../../assets/img/p1_b_01.b78c060f.jpg';
import pay1_btn from '../../assets/img/panic_buying_btn.png';
import pay2_btn from '../../assets/img/panic_buying_btn.png';
import bg1 from '../../assets/img/2020.10_01.jpg';
import bg2 from '../../assets/img/2.png';
import bg3 from '../../assets/img/3.png';
import bg4 from '../../assets/img/4.png';
import bg5 from '../../assets/img/5.png';
import bg6 from '../../assets/img/6.png';
import bg7 from '../../assets/img/2020.10_02.jpg';
import bg8 from '../../assets/img/优惠券.png';
import bg9 from '../../assets/img/优惠btn.png';
// import bg7 from '../../assets/img/7.png';

import countDown_btn from '../../assets/img/soon_learn_btn.png';
import style from './style.module.css'
import Mypopuptwo from "../OderInfo/Mypopuptwo"
// import {getUrl} from '../../utils/tool'
import {useUrlQuery} from '../../utils/useFunc'
import ProtocolDetails from '../ProtocolDetails/index';


var computePX = function(devBase, nowBase) {
    var ratio = nowBase / devBase;
    return function(devPx) {
        return ratio * devPx;
    };
}

export default () => {
    let {sku_id,qudao} = useUrlQuery(); //获取url上的sku_id和渠道
    let [timer, setTimer] = useState(null);
    let [hour, setHour] = useState('08');
    let [minute, setMinute] = useState('00');
    let [second, setSecond] = useState('00');
    let [priceType, setPriceType] = useState(pay1_btn);
    let [agrement, setAgrement] = useState(false);
    let [visible, setVisible] = useState(false);
    let [width, setWidth] = useState('');
    let [marginleft, setMarginleft] = useState('');

    const [modal2, setModal2] = useState(false)

    let [sum, setSum] = useState('98');
    let [td, setTd] = useState('9');
    let [ud, setUd] = useState('8');

    let [nowTime] = useState(new Date().getTime());
    // 是否显示用户协议
    function showAgrement(bol){
        if(bol == true){
            setVisible(() => true)
        }else{
            setVisible(() => false)

        }
        setAgrement(() => bol)
    }
    // 判断是否在微信内
    function isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            setWidth(() => computePX(375, window.innerWidth)(16) + 'px')
            setMarginleft(() => computePX(375, window.innerWidth)(6) + 'px')
        } else {
            setWidth(() => computePX(375, window.innerWidth)(16) + 'px')
            setMarginleft(() => computePX(375, window.innerWidth)(0) + 'px')
        }
    }

    function formatTime(num){
        let dateNum = num + '';
        if(dateNum.length === 1){
            return '0' + num;
        }else{
            return num
        }
    }
    // 八小时候的时间
    function formatDate(date){
        return date + 3600000  * 8;
    }
    //时间
    const countDownTime = useCallback((time,nowDate,countTime) => {
        // 时
        let getDatTimeHour =(time - nowDate) % (24 * 3600 * 1000)
        let timestampHour = Math.floor(getDatTimeHour / (3600 * 1000));
        // 分
        let getDatTimeMinute = getDatTimeHour %  (3600 * 1000);
        let timestampMinute = Math.floor(getDatTimeMinute / (60 * 1000));
        // 秒
        let getDatTimeSecond = getDatTimeMinute % (60 * 1000);
        let timestampSecond = Math.floor(getDatTimeSecond / 1000);
        setHour(formatTime(timestampHour));
        setMinute(formatTime(timestampMinute));
        setSecond(formatTime(timestampSecond));
        if((parseInt(timestampHour) === 0) && (parseInt(timestampMinute) === 0) && (parseInt(timestampSecond) === 0)){
            sessionStorage.removeItem('deadlineDate')
            clearInterval(countTime)
        }
    },[])
    // 获取sku_id
    // 获取sku_id，url没有就设置默认值
    if(sku_id){
        sessionStorage.setItem('sku_id',sku_id);
        localStorage.setItem('sku_id',sku_id);
        /*sessionStorage.setItem('url',window.location.href);
        localStorage.setItem('url',window.location.href);*/
        sessionStorage.setItem('url','p2');
    }else{
        sessionStorage.setItem('sku_id',1);
        localStorage.setItem('sku_id',1)
        /*sessionStorage.setItem('url',window.location.href);
        localStorage.setItem('url',window.location.href);*/
        sessionStorage.setItem('url','p2');
    }
    useEffect(() =>{
        // 根据sku_id判断商品价格
        if((sessionStorage.getItem('sku_id') == 1) || (localStorage.getItem('sku_id') == 1)){
            setPriceType(pay1_btn)
        }else{
            setPriceType(pay2_btn)
        }
        isWeiXin();
    },[])

    // 获取渠道
    useEffect(() =>{
        if(qudao){
            sessionStorage.setItem('channel',qudao);
            localStorage.setItem('channel',qudao);
        }else{
            sessionStorage.setItem('channel','tengxun');
            localStorage.setItem('channel','tengxun');
        }
    },[qudao])

    useEffect(() => {
        let hash = window.location.hash;
        hash = hash.indexOf('checked=true');
        if(hash != -1){
            setModal2(true);
        }
    },[])

    //名额倒计时
    useEffect(() => {
        let tiemId = setInterval(() => {
            sum = sum - parseInt((2*Math.random())+1);
            td = parseInt((sum%100)/10);
            ud = parseInt(sum%10)
            setSum(sum)
            setTd(td)
            setUd(ud)
            if(sum <= 10){
                clearInterval(tiemId)
                setTd(0)
                setUd(0)
            }
        }, 5000);
    },[])

    // 计时器
    useEffect(() => {
        let countTime = 0;
        if(!timer){
            setTimer(1);
            countTime = setInterval(() => {
                if(!sessionStorage.getItem('deadlineDate')){
                    sessionStorage.setItem('deadlineDate',formatDate(nowTime))
                    countDownTime(formatDate(nowTime),nowTime,countTime)

                }else{
                    countDownTime(sessionStorage.getItem('deadlineDate'),new Date().getTime(),countTime);
                }
            }, 1000)
        };
        return function clearCountTime(){
            if(timer){
                clearInterval(countTime)
            }
        }
    },[timer,setTimer,countDownTime,nowTime]);

    let timerStyle = {
        right: computePX(375, window.innerWidth)(22) + 'px',
        bottom: computePX(375, window.innerWidth)(8) + 'px'
    }
    let timeShare = {
        // width: computePX(375, window.innerWidth)(16) + 'px',
        width: width,
        height: computePX(375, window.innerWidth)(14) + 'px',
        marginleft: marginleft
    }

    let imgWidth = {
        width: computePX(375,window.innerWidth)(140) + 'px',
        height: computePX(375,window.innerWidth)(49) + 'px'
    }

    return <div>
        <div className={style.content}>
            {/* <img alt="图片" style={{width: '100%'}} src={p1_bImg}></img> */}
            <img alt="图片" style={{width: '100%'}} src={bg1}></img>
            <div style={{width: '100%'}} className={style.couponBox}>
                <img style={{width: '100%'}} alt="图片" src={bg7}></img>
                <img alt="图片" src={bg8} className={style.coupon} onClick={() => setModal2(true)}></img>
                <img alt="图片" src={bg9} className={style.couponBtn} onClick={() => setModal2(true)}></img>
            </div>
            <img alt="图片" style={{width: '100%'}} src={bg2}></img>
            <img alt="图片" style={{width: '100%'}} src={bg3}></img>
            <img alt="图片" style={{width: '100%'}} src={bg4}></img>
            <img alt="图片" style={{width: '100%'}} src={bg5}></img>
            <img alt="图片" style={{width: '100%'}} src={bg6}></img>
            {/*<img alt="图片" style={{width: '100%'}} src={bg7}></img>*/}
        </div>
        <div className={style.submit}>
            <img alt="图片" style={{width: '100%'}} src={priceType} onClick={() => setModal2(true)}></img>
            {/* <div className={style.submit_num}>
                <span className={style.num1}>{td}</span>
                <span className={style.num2}>{ud}</span>
            </div> */}
            <div className="box_scale" style={imgWidth} className={style.countDown_btn}>
                <img alt="图片" style={{width: '100%'}} src={countDown_btn} onClick={() => setModal2(true)}></img>
                {/* <div className={style.timeDown} style={timerStyle}>
                    <div className={style.hour} style={timeShare}>{ hour }</div>
                    <div className={style.minute} style={timeShare}>{ minute }</div>
                    <div className={style.second} style={timeShare}>{ second }</div>
                </div> */}

            </div>

        </div>
        <Mypopuptwo visible={modal2} onClose={() =>setModal2(false)} afterClose={()=>{}} sku_id={localStorage.getItem('sku_id')} changeShow={showAgrement}/>
        {
            agrement ?
                <div className={style.contract}>
                    <ProtocolDetails changeShow={showAgrement} visible={visible}/>
                </div>
                :
                null
        }

    </div>;
}
